<template>
  <div class="blockChain">
    <router-view v-if="isRouterAlive"></router-view>
    <div class="footer" :class="{'validate': footerType == '2'}">
      <div class="disnone">

        <div class="top">
          <div class="content">
            <i class="ft14" style="float:left">{{ lanInfo.footer.OfficialWebsite }}www.legalxchain.com</i>
            <i class="ft14">{{ lanInfo.footer.SDKContact }}Sdk.legalxchain.com</i>
            <i class="ft14" style="float:right">{{ lanInfo.footer.JoinUs }}join@legalxchain.com</i>
          </div>

        </div>
        <div style="width:100%;height:1px;background:#153b86;"></div>
      </div>

      <div class="bottom">
        <!-- <p
          class="ft12"
        >Copyright© 2018-2022 All Rights Reserved | {{lanInfo.footer.copy}} | 京ICP备16033891号-5 | 京网信备11010519496506010015</p>-->
        <!-- <p class="ft12">公安部安全与警用电子产品质量检测中心 | 国家安全防范报警系统产品质量监督检验中心（北京）</p> -->
        <p class="ft12">Copyright© 2018-{{ yearTIme }} All Rights Reserved | 版权所有：真相网络科技（北京）有限公司</p>
        <p class="ft12">
          <a class="icp-link" target="_blank" href="https://beian.miit.gov.cn/" style="">京ICP备16033891号-5</a> |
          <img src="@/assets/images/police_logo.png" alt/> <a class="icp-link" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038162
">京公网安备 11010502038162号</a> | 京网信备11010519496506010015号
        </p>
      </div>
    </div>
    <Drawer v-if="isshowDrawer" :opens="true"></Drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Drawer from "./common/drawer";

export default {
  name: "index",
  data() {
    return {
      menuData: [
        {name: "home", id: "1", routerLink: "home"},
        {name: "blockBrowser", id: "2", routerLink: "blockChain"},
        {name: "internetCourt", id: "3", routerLink: "internetCourt"},
        {name: "validateQuery", id: "4", routerLink: "validateQuery"},
        {
          name: "evidenceExtraction",
          id: "5",
          routerLink: "evidenceExtraction"
        },
        {name: "solution", id: "6", routerLink: "solution"},
        {name: "whitePaper", id: "7", routerLink: "technology"},
        {name: "contactUs", id: "8", routerLink: "contact"}
      ],
      isshowDrawer: false,
      isRouterAlive: true,
      yearTIme:new Date().getFullYear()
    }
  },
  components: {
    Drawer
  },
  created() {
  },
  mounted() {
    // console.log(this.$route,"当前路由");
    const path = this.$route.path;
    const len = this.menuData;
    for (let i = len.length; i--;) {
      // if (path == len[i].routerLink) {
      //   this.id = len[i].id;
      // }
      if (path.indexOf(len[i].routerLink) > 0) {
        this.id = len[i].id;
        this.isshowDrawer = true;
      }
    }
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo;
    },

    ...mapState(["footerType"])
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  }

};
</script>

<style scoped lang="scss">
.blockChain {
  width: 100%;

  .footer {
    height: 178px;
    background: #0e285a;

    .bottom {
      // background: #0e285a;
      width: 1200px;
      // height: 112px;
      margin: 0 auto;
      padding-top: 20px;
    }

    p {
      color: #c0d3f8;
      text-align: center;
      line-height: 30px;
      // background: #0e285a;
      width: 1200px;
      margin: 0 auto;

      a {
        color: #c0d3f8;
      }

      .icp-link:hover {
        color: #0A57C9;
      }

      img {
        vertical-align: middle;
      }
    }

    .top {
      height: 64px;
      width: 1200px;
      margin: 0 auto;
      // background: #0e285a;
      // border-bottom: 1px solid #153b86;
      .content {
        width: 1200px;
        height: 64px;
        line-height: 64px;
        margin: 0 auto;
        text-align: center;

        i {
          font-style: normal;
          color: #c0d3f8;
        }
      }
    }

    &.validate {
      height: 112px;
      background: #eeeeee;

      p {
        color: #787878;
      }

      a {
        color: #787878;
      }

      .icp-link:hover {
        color: #0A57C9;
      }

      .disnone {
        display: none;
      }
    }
  }
}

.icp-link {
  display: inline-block;
  text-decoration: none;
  height: 20px;
  line-height: 20px;
}

</style>
